var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnionLeftArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1498 2.8666L45.7694 0.486179L45.3983 0.115086L8.91762 36.5958C9.32408 33.9614 9.55523 31.0169 9.43822 28.0046C9.20302 21.9502 7.54566 15.3396 2.7439 10.5378L-0.00762007 13.2894C3.82476 17.1217 5.3342 22.6029 5.54991 28.1557C5.76498 33.692 4.67827 39.0187 3.62627 42.178L5.37655 43.2593L6.45799 45.0097C9.61724 43.9577 14.944 42.871 20.4803 43.0861C26.0331 43.3018 31.5142 44.8112 35.3466 48.6436L38.0981 45.8921C33.2964 41.0903 26.6857 39.433 20.6314 39.1978C17.6191 39.0808 14.6746 39.3119 12.0402 39.7184L48.5209 3.2377L48.1498 2.8666Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnionLeftArrow);
export default __webpack_public_path__ + "static/media/union_left_arrow.26c1662880da749cf1b915402989f2f5.svg";
export { ForwardRef as ReactComponent };